module.exports = __webpack_public_path__ + "img/浙江商业.2ca16f1e.png";